export const formatSquareMeterValue = (value: string) => {
  return Number(value).toFixed(2).replace('.', ',');
};

export const formatDimensionsRange = (range: string) => {
  const splittedRange = range.split(', ');

  return `De ${formatSquareMeterValue(
    splittedRange[0]
  )} até ${formatSquareMeterValue(splittedRange[1])} m²`;
};
